import { render, staticRenderFns } from "./dialogs-list.vue?vue&type=template&id=e8b9c6d2&scoped=true&"
import script from "./dialogs-list.vue?vue&type=script&lang=js&"
export * from "./dialogs-list.vue?vue&type=script&lang=js&"
import style0 from "./dialogs-list.vue?vue&type=style&index=0&id=e8b9c6d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8b9c6d2",
  null
  
)

export default component.exports